import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useCommonApi() {
    const callApi = useApiCall()

    const countries = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.COUNTRY, data, onSuccess, onError)
    }

    const zones = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.ZONE, data, onSuccess, onError)
    }

    const roles = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.ROLE, data, onSuccess, onError)
    }

    const businessFunction = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.BUSINESS_FUNCTION, data, onSuccess, onError)
    }
    const getUseCases = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.USE_CASES, data, onSuccess, onError)
    }
    const getKpiInterests = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.KPI_INTERESTS, data, onSuccess, onError)
    }
    const getKpiTypes = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.KPI_TYPES, data, onSuccess, onError)
    }
    const getExperimentTypes = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.EXPERIMENTS_TYPES, data, onSuccess, onError)
    }

    const getCommonDropdown = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.ALLDROPDOWN, data, onSuccess, onError)
    }

    const getUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.USERS, data, onSuccess, onError)
    }

    const getExptSharableUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.EXPT_SHARABLE_USER, data, onSuccess, onError)
    }

    const getTopActiveUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.TOP_ACTIVE_USERS, data, onSuccess, onError)
    }

    const getGroupDownExpStatus = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.DROPDOWN_EXPERIMENT_STATUS, data, onSuccess, onError)
    }
    const getAdvanceConfigOption = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.ADVANCE_CONFIG_OPTION, data, onSuccess, onError)
    }
    const getProdcutInfo = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.PRODUCT_INFO, data, onSuccess, onError)
    }

    const getCurrency = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.GET_CURRENCY, data, onSuccess, onError)
    }
    const getVolume = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.GET_VOLUME, data, onSuccess, onError)
    }
    const getExperimentAccess = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.GET_EXPERIMENT_ACCESS, data, onSuccess, onError)
    }
    const getAdvanceConfigurationOption = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.COMMON.GET_ADVANCE_CONFIG_OPTION, data, onSuccess, onError)
    }

    return {
        countries,
        roles,
        businessFunction,
        zones,
        getUseCases,
        getKpiInterests,
        getKpiTypes,
        getExperimentTypes,
        getCommonDropdown,
        getUsers,
        getExptSharableUsers,
        getTopActiveUsers,
        getGroupDownExpStatus,
        getAdvanceConfigOption,
        getProdcutInfo,
        getCurrency,
        getVolume,
        getExperimentAccess,
        getAdvanceConfigurationOption,
    }
}
